module.exports = __webpack_public_path__ + "assets/img/1401.dcacd021.png";